/* unplugin-vue-components disabled */import __unplugin_components_20 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-confirm.vue';
import { ElForm as __unplugin_components_19 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import __unplugin_components_18 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-form-item.vue';
import __unplugin_components_17 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-input.vue';
import __unplugin_components_16 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-dialog.vue';
import __unplugin_components_15 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/add-custom-token-dialog.vue';
import __unplugin_components_14 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/add-token-dialog.vue';
import { ElDrawer as __unplugin_components_13 } from 'element-plus/es';import 'element-plus/es/components/drawer/style/css';
import __unplugin_components_12 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/receive-dialog.vue';
import { ElTabs as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/tabs/style/css';
import __unplugin_components_10 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-nft-image.vue';
import __unplugin_components_9 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-collection.vue';
import { ElTabPane as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/tab-pane/style/css';
import __unplugin_components_7 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-button.vue';
import __unplugin_components_6 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-dollar.vue';
import __unplugin_components_5 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-token.vue';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElProgress as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/progress/style/css';
import { ElTooltip as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import __unplugin_components_1 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-home-page-header.vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, withKeys as _withKeys, withModifiers as _withModifiers } from "vue";
import _imports_0 from '@/assets/img/connect/wallet-connect.svg';
import _imports_1 from '@/assets/img/index/AP.svg';
import _imports_2 from '@/assets/img/index/question.svg';
import _imports_3 from '@/assets/img/index/nft-none-dark.svg';
import _imports_4 from '@/assets/img/index/nft-none-light.svg';
const _hoisted_1 = {
  id: "page-index",
  class: "header-bg-img"
};
const _hoisted_2 = {
  class: "main-container"
};
const _hoisted_3 = {
  class: "box"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("span", null, "WalletConnect")], -1);

const _hoisted_5 = {
  class: "lump-sum-box"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "lump-sum"
};
const _hoisted_8 = {
  class: "worth"
};
const _hoisted_9 = {
  class: "ap-wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "ap-icon",
  src: _imports_1
}, null, -1);

const _hoisted_11 = {
  class: "ap-balance"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "question-icon",
  src: _imports_2
}, null, -1);

const _hoisted_13 = {
  class: "shortcut"
};
const _hoisted_14 = {
  class: "btn-box"
};
const _hoisted_15 = {
  class: "btn"
};
const _hoisted_16 = {
  class: "btn-box"
};
const _hoisted_17 = {
  key: 1,
  class: "recovering"
};
const _hoisted_18 = {
  class: "progress"
};
const _hoisted_19 = {
  class: "coin-box"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "top"
};
const _hoisted_22 = {
  class: "balance"
};
const _hoisted_23 = {
  key: 0,
  class: "bottom"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "balance"
};
const _hoisted_26 = {
  key: 0,
  class: "bottom"
};
const _hoisted_27 = {
  class: "nft-content"
};
const _hoisted_28 = {
  class: "nft-title"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 0,
  class: "nft-none"
};
const _hoisted_31 = {
  key: 0,
  src: _imports_3
};
const _hoisted_32 = {
  key: 1,
  src: _imports_4
};
const _hoisted_33 = {
  class: "el-dialog__subtitle"
};
const _hoisted_34 = {
  class: "scan-modal-content"
};
const _hoisted_35 = {
  class: "scan-video"
};
const _hoisted_36 = {
  class: "scan-video-container"
};
const _hoisted_37 = {
  class: "video-container"
};
const _hoisted_38 = ["attr-scanning"];

const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "border-container"
}, [/*#__PURE__*/_createElementVNode("div"), /*#__PURE__*/_createElementVNode("div"), /*#__PURE__*/_createElementVNode("div"), /*#__PURE__*/_createElementVNode("div")], -1);

const _hoisted_40 = {
  class: "paste-btn"
};
import { useIndex, useIndexCoin, useIndexRecovery, useIndexWalletConnect } from '@/composable/useIndex';
import { useCoinStore } from '@/store/coin';
import { useNftStore } from '@/store/nft';
import { formatBalance, formatPassword, isMobile } from '@/utils/useUniPass';
import { toThousandsString } from '@/utils/account-token/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const coinStore = useCoinStore();
    const nftStore = useNftStore();
    const {
      showReceive,
      showAddToken,
      showAddCustomToken,
      isDark,
      chainAccountStore
    } = useIndex();
    const {
      toBuyCoins,
      sendCoin
    } = useIndexCoin();
    const {
      chainName,
      walletConnectStore,
      scan,
      scanModal,
      cameraElement
    } = useIndexWalletConnect();
    const {
      cancelRecovery,
      recovering,
      auth,
      beforeCancelRecovery
    } = useIndexRecovery();
    const route = useRoute();

    if (route.query.tab === 'collection') {
      nftStore.activeTab = route.query.tab;
    }

    const router = useRouter();

    const sendNFT = (nft, collection) => {
      nftStore.nft = nft;
      nftStore.collection = collection;
      router.push({
        path: '/send-nft'
      });
    };

    const tabChange = tab => {
      const obj = new window.URL(window.location.href);
      obj.searchParams.set('tab', tab);
      window.history.replaceState({}, '', obj.href);
    };

    const customTokenBack = () => {
      showAddToken.value = true;
      showAddCustomToken.value = false;
    };

    const customTokenClose = () => {
      showAddToken.value = false;
      showAddCustomToken.value = false;
    };

    return (_ctx, _cache) => {
      const _component_up_home_page_header = __unplugin_components_0;

      const _component_router_link = _resolveComponent("router-link");

      const _component_up_icon = __unplugin_components_1;

      const _component_el_tooltip = __unplugin_components_2;

      const _component_el_progress = __unplugin_components_3;

      const _component_el_button = __unplugin_components_4;

      const _component_up_token = __unplugin_components_5;

      const _component_up_dollar = __unplugin_components_6;

      const _component_up_button = __unplugin_components_7;

      const _component_el_tab_pane = __unplugin_components_8;

      const _component_up_collection = __unplugin_components_9;

      const _component_up_nft_image = __unplugin_components_10;

      const _component_el_tabs = __unplugin_components_11;

      const _component_receive_dialog = __unplugin_components_12;

      const _component_el_drawer = __unplugin_components_13;

      const _component_add_token_dialog = __unplugin_components_14;

      const _component_add_custom_token_dialog = __unplugin_components_15;

      const _component_up_dialog = __unplugin_components_16;

      const _component_up_input = __unplugin_components_17;

      const _component_up_form_item = __unplugin_components_18;

      const _component_el_form = __unplugin_components_19;

      const _component_up_confirm = __unplugin_components_20;

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_up_home_page_header), _unref(walletConnectStore).pairings.length > 0 ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/wallet-connect",
        class: "wallet-connect"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
          class: _normalizeClass(["right up-chain", _unref(chainName)])
        }, _toDisplayString(_unref(chainName)), 3)])]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('TotalAmount')), 1), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, "$" + _toDisplayString(_unref(coinStore).showLumpSum ? _unref(coinStore).netWorth : '*****'), 1), _createVNode(_component_up_icon, {
        onClick: _cache[0] || (_cache[0] = $event => _unref(coinStore).showLumpSum = !_unref(coinStore).showLumpSum),
        name: _unref(coinStore).showLumpSum ? 'eyes-open' : 'eyes-close'
      }, null, 8, ["name"])], 512), [[_vShow, _unref(coinStore).netWorth !== '-']]), _withDirectives(_createVNode(_component_up_icon, {
        name: "loading",
        class: "is-loading duration"
      }, null, 512), [[_vShow, _unref(coinStore).netWorth === '-']])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(coinStore).apBalance) + " AP", 1), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: _ctx.$t('APDescription'),
        placement: "bottom"
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      }, 8, ["content"])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        (...args) => _unref(scanModal).open && _unref(scanModal).open(...args))
      }, [_createVNode(_component_up_icon, {
        name: `scan-${_unref(isDark) ? 'dark' : 'light'}`
      }, null, 8, ["name"])]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('Scan')), 1)]), _createElementVNode("div", {
        class: "btn-box active",
        onClick: _cache[2] || (_cache[2] = $event => showReceive.value = true)
      }, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_up_icon, {
        name: "receive-dark"
      })]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('Receive')), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        class: "btn",
        onClick: _cache[3] || (_cache[3] = //@ts-ignore
        (...args) => _unref(toBuyCoins) && _unref(toBuyCoins)(...args))
      }, [_createVNode(_component_up_icon, {
        name: `buy-${_unref(isDark) ? 'dark' : 'light'}`
      }, null, 8, ["name"])]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('Buy')), 1)])]), _unref(chainAccountStore).isPending ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_progress, {
        "text-inside": true,
        format: percentage => `${percentage}% ${_ctx.$t('Recovering')}...`,
        "stroke-width": 24,
        percentage: Number(_unref(chainAccountStore).progress)
      }, null, 8, ["format", "percentage"])]), _createVNode(_component_el_button, {
        loading: _unref(recovering).loading,
        round: "",
        type: "danger",
        size: "small",
        onClick: _unref(beforeCancelRecovery)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Cancel')), 1)]),
        _: 1
      }, 8, ["loading", "onClick"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_tabs, {
        modelValue: _unref(nftStore).activeTab,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(nftStore).activeTab = $event),
        onTabChange: tabChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: _ctx.$t('Token'),
          name: "token"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coinStore).coins, (coin, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: "coin",
              onClick: $event => _unref(coinStore).active = _unref(coinStore).active === i ? -1 : i
            }, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_up_token, {
              name: coin.name,
              symbol: coin === null || coin === void 0 ? void 0 : coin.symbol,
              chain: coin.chain,
              icon: coin.logoURI,
              type: "index"
            }, null, 8, ["name", "symbol", "chain", "icon"]), _createElementVNode("div", _hoisted_22, [_withDirectives(_createVNode(_component_up_icon, {
              name: "loading",
              class: "is-loading duration"
            }, null, 512), [[_vShow, !coin.inited]]), _withDirectives(_createElementVNode("div", null, _toDisplayString(_unref(toThousandsString)(_unref(formatBalance)(coin.balance || '0'))), 513), [[_vShow, coin.inited]]), _withDirectives(_createVNode(_component_up_dollar, {
              symbol: coin.symbol,
              price: coin.price,
              balance: coin.balance,
              decimals: coin.decimals
            }, null, 8, ["symbol", "price", "balance", "decimals"]), [[_vShow, coin.inited]])])]), _unref(coinStore).active === i ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_up_button, {
              type: "primary",
              onClick: $event => _unref(sendCoin)(i)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Transfer')), 1)]),
              _: 2
            }, 1032, ["onClick"])])) : _createCommentVNode("", true)], 8, _hoisted_20);
          }), 128)), _withDirectives(_createVNode(_component_up_icon, {
            name: "loading",
            class: "collection-loading is-loading"
          }, null, 512), [[_vShow, _unref(coinStore).coins.length === 0]])]),
          _: 1
        }, 8, ["label"]), _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('Collection'),
          name: "collection"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nftStore).collectionList, (item, i) => {
            return _openBlock(), _createElementBlock("div", {
              class: "nft",
              key: i
            }, [_createElementVNode("div", {
              class: _normalizeClass(["top", {
                active: !_unref(isDark) && _unref(nftStore).activeCollectionIndex === i
              }]),
              onClick: $event => _unref(nftStore).clickCollection(item, i)
            }, [_createVNode(_component_up_collection, {
              collection: item,
              type: "index"
            }, null, 8, ["collection"]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, _toDisplayString(item.totalTokens), 1)])], 10, _hoisted_24), _unref(nftStore).activeCollectionIndex === i ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_withDirectives(_createVNode(_component_up_icon, {
              name: "loading",
              class: "is-loading"
            }, null, 512), [[_vShow, _unref(nftStore).currentCollection.length === 0]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nftStore).currentCollection, (token, i2) => {
              return _openBlock(), _createElementBlock("div", {
                class: "nft-item",
                key: i2
              }, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_up_nft_image, {
                "image-url": token.imageUrl,
                "chain-id": item.chainId,
                "contract-address": item.contractAddress,
                "token-id": token.tokenId
              }, null, 8, ["image-url", "chain-id", "contract-address", "token-id"]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", null, _toDisplayString(token.title) + " #" + _toDisplayString(token.tokenId), 1), token.total > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t('Quantity')) + ": ×" + _toDisplayString(token.total), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", null, [_createVNode(_component_up_button, {
                class: "send-button",
                size: "small",
                type: "primary",
                onClick: $event => sendNFT(token, item)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Transfer')), 1)]),
                _: 2
              }, 1032, ["onClick"])])]);
            }), 128))])) : _createCommentVNode("", true)]);
          }), 128)), _withDirectives(_createVNode(_component_up_icon, {
            name: "loading",
            class: "collection-loading is-loading"
          }, null, 512), [[_vShow, _unref(nftStore).collectionLoading]]), _unref(nftStore).collectionList.length === 0 && _unref(nftStore).collectionLoading === false ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_unref(isDark) ? (_openBlock(), _createElementBlock("img", _hoisted_31)) : (_openBlock(), _createElementBlock("img", _hoisted_32)), _createElementVNode("div", null, _toDisplayString(_ctx.$t('NotCollections')), 1)])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 8, ["modelValue"]), _unref(nftStore).activeTab === 'token' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "add-token-box",
        onClick: _cache[5] || (_cache[5] = $event => showAddToken.value = true)
      }, [_createVNode(_component_up_icon, {
        name: "add-token"
      })])) : _createCommentVNode("", true)])]), _unref(isMobile)() ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_drawer, {
        modelValue: _unref(showReceive),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(showReceive) ? showReceive.value = $event : null),
        "with-header": false,
        "custom-class": "drawer-receive",
        direction: "btt",
        size: "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_receive_dialog, {
          onClose: _cache[6] || (_cache[6] = $event => showReceive.value = false)
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_drawer, {
        modelValue: _unref(showAddToken),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _isRef(showAddToken) ? showAddToken.value = $event : null),
        "with-header": false,
        "custom-class": "drawer-add-token-dialog",
        direction: "btt",
        "destroy-on-close": true,
        size: "90%"
      }, {
        default: _withCtx(() => [_createVNode(_component_add_token_dialog, {
          onClose: _cache[8] || (_cache[8] = $event => showAddToken.value = false),
          onAddCustomToken: _cache[9] || (_cache[9] = $event => showAddCustomToken.value = true)
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_drawer, {
        modelValue: _unref(showAddCustomToken),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(showAddCustomToken) ? showAddCustomToken.value = $event : null),
        "with-header": false,
        "custom-class": "drawer-add-custom-token-dialog",
        direction: "btt",
        "destroy-on-close": true,
        size: "90%"
      }, {
        default: _withCtx(() => [_createVNode(_component_add_custom_token_dialog, {
          onClose: customTokenClose,
          onBack: customTokenBack
        })]),
        _: 1
      }, 8, ["modelValue"])], 64)) : _createCommentVNode("", true), !_unref(isMobile)() ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_up_dialog, {
        class: "drawer-receive-dialog",
        modelValue: _unref(showReceive),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _isRef(showReceive) ? showReceive.value = $event : null)
      }, {
        default: _withCtx(() => [_createVNode(_component_receive_dialog, {
          onClose: _cache[12] || (_cache[12] = $event => showReceive.value = false)
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_up_dialog, {
        class: "drawer-add-token-dialog",
        modelValue: _unref(showAddToken),
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _isRef(showAddToken) ? showAddToken.value = $event : null)
      }, {
        default: _withCtx(() => [_createVNode(_component_add_token_dialog, {
          onClose: _cache[14] || (_cache[14] = $event => showAddToken.value = false),
          onAddCustomToken: _cache[15] || (_cache[15] = $event => showAddCustomToken.value = true)
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_up_dialog, {
        class: "drawer-add-custom-token-dialog",
        modelValue: _unref(showAddCustomToken),
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _isRef(showAddCustomToken) ? showAddCustomToken.value = $event : null),
        "destroy-on-close": true
      }, {
        default: _withCtx(() => [_createVNode(_component_add_custom_token_dialog, {
          onClose: customTokenClose,
          onBack: customTokenBack
        })]),
        _: 1
      }, 8, ["modelValue"])], 64)) : _createCommentVNode("", true), _createVNode(_component_up_confirm, {
        title: _ctx.$t('CancelRecovery'),
        modelValue: _unref(auth).show,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _unref(auth).show = $event),
        "destroy-on-close": "",
        onClosed: _cache[23] || (_cache[23] = $event => _unref(auth).password = '')
      }, {
        footer: _withCtx(() => [_createVNode(_component_up_button, {
          type: "primary",
          disabled: !_unref(auth).password,
          loading: _unref(recovering).loading,
          onClick: _unref(cancelRecovery)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Confirm')), 1)]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('InputYourPassword')), 1), _createVNode(_component_el_form, {
          onSubmit: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent"])),
          ref: "authElement",
          model: _unref(auth)
        }, {
          default: _withCtx(() => [_createVNode(_component_up_form_item, {
            label: _unref(auth).password && _ctx.$t('Password'),
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_up_input, {
              onInput: _cache[18] || (_cache[18] = v => _unref(auth).password = _unref(formatPassword)(v)),
              modelValue: _unref(auth).password,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(auth).password = $event),
              placeholder: _ctx.$t('EnterPassword'),
              disabled: _unref(recovering).loading,
              onKeydown: _cache[20] || (_cache[20] = _withKeys($event => _unref(auth).password && _unref(cancelRecovery)(), ["enter"])),
              "show-password": "",
              clearable: ""
            }, null, 8, ["modelValue", "placeholder", "disabled"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_component_up_confirm, {
        title: _ctx.$t('Scan'),
        modelValue: _unref(scan).isScanning,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(scan).isScanning = $event),
        onClose: _unref(scanModal).close,
        onClosed: _unref(scanModal).close
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("video", {
          ref_key: "cameraElement",
          ref: cameraElement,
          playsinline: "",
          "attr-scanning": _unref(scan).isScanning
        }, null, 8, _hoisted_38)]), _hoisted_39])]), _createElementVNode("div", _hoisted_40, [_createVNode(_component_up_button, {
          type: "info",
          onClick: _unref(scanModal).pasteCode
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('PasteWalletConnectCode')), 1)]),
          _: 1
        }, 8, ["onClick"])])])]),
        _: 1
      }, 8, ["title", "modelValue", "onClose", "onClosed"])]);
    };
  }

});